<template>
    <div v-if="isShowCompleteButton" class="patent-view__side-function-task">
        <button
            class="pt-ui-btn"
            :data-type="isDone ? 'default' : 'primary'"
            :disabled="isDone || isLoadingList || isSubmitting"
            @click="doneReview"
        >
            {{ submitText }}
        </button>
    </div>
</template>

<script>
import { getTaskPatentsApi, doneTaskReviewApi, getTaskCustomFieldValuesApi } from '../../../../../../components/apis/workspace_api/task';
import { get, find, set, forEach, cloneDeep } from 'lodash';

export default {
    name: 'TaskAssign',
    props: {
        viewParams: {
            type: Object,
            required: true
        },
        patentId: {
            type: String,
            required: true
        }
    },
    computed: {
        taskId() {
            return get(this.viewParams, 'task_id');
        },
        taskType() {
            return parseInt(get(this.viewParams, 'task_type', 1));
        },
        isShowCompleteButton() {
            let fromType = 2;
            const { assigner, assignee, current_user, is_assigner } = this.taskBasicInfo;
            // 自己分配给自己
            if (current_user === assigner && current_user === assignee) {
                fromType = this.taskType || 1;
            } else {
                fromType = is_assigner ? 2 : 1;
            }
            return fromType === 1;
        },
        isDone() {
            const currentPatent = find(this.taskPatentList, { patent_id: this.patentId });
            return get(currentPatent, 'status') === 'DONE';
        },
        submitText() {
            let text = '';
            if (this.isLoadingList || this.isSubmitting) {
                text = this.$t('loading');
            } else if (this.isDone) {
                text = this.$t('task.actionReviewDone');
            } else {
                text = this.$t('task.actionReview');
            }
            return text;
        }
    },
    watch: {
        customFieldDefs(val) {
            this.$emit('customFieldDefsUpdate', val);
        },
        patentId() {
            this.getTaskCustomFieldValues();
        },
        isDone: {
            handler(val) {
                this.$emit('statusChange', val);
            },
            immediate: true
        },
        isLoadingList(val) {
            this.$emit('loadingChange', val);
        }
    },
    data() {
        return {
            taskBasicInfo: {},
            taskPatentList: [],
            customFieldDefsOrigin: [],
            customFieldDefs: [],
            isLoadingList: false,
            isSubmitting: false
        };
    },
    methods: {
        async getTaskList() {
            this.isLoadingList = true;
            if (!this.taskId) return this.taskPatentList = [];
            const data = await getTaskPatentsApi({ task_id: this.taskId });
            this.taskPatentList = get(data, 'patents', []);
            this.customFieldDefs = get(data, 'custom_field_defs', []);
            this.customFieldDefsOrigin = get(data, 'custom_field_defs', []);
            this.taskBasicInfo = get(data, 'task_info', {});
            this.isLoadingList = false;
        },
        async getTaskCustomFieldValues() {
            const data = await getTaskCustomFieldValuesApi({ task_id: this.taskId, patent_id: this.patentId });
            let fieldIds = Object.keys(data);
            const newData = cloneDeep(this.customFieldDefsOrigin);
            forEach(fieldIds, value => {
                let field = find(newData, { field_id: value });
                if (!field) return;
                set(field, 'field_value', data[value]);
            });
            this.customFieldDefs = newData;
        },
        async doneReview() {
            this.isSubmitting = true;
            await doneTaskReviewApi({ task_id: this.taskId, patent_id: this.patentId });
            set(find(this.taskPatentList, { patent_id: this.patentId }), 'status', 'DONE');
            this.isSubmitting = false;
        }
    },
    async created() {
        await this.getTaskList();
        await this.getTaskCustomFieldValues();
    }
};
</script>

<style lang="scss">
.patent-view__side-function-task {
    padding: 16px;
    border-top: 1px solid #ebecf0;
    text-align: center;
    .pt-ui-btn {
        padding: 3px 15px;
        width: 100%;
    }
}
</style>
